import {tokens} from "locales/tokens";

const translateText = (code: string | undefined, t: (key: string) => string, tokenMap: { [key: string]: string }) => {
    if(code === undefined) {
        return '-'
    }

    return t(tokenMap[code] || '-');
};

/*
USE: 사용
UNUSE: 미사용
END: 종결
 */
export const translateGoodsStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'USE': tokens.code.gd_use_typ_use,
        'UNUSE': tokens.code.gd_use_typ_unuse,
        'END': tokens.code.gd_use_typ_end,
    });
};

/*
DAY: 일재고
KEEP: 보관재고
DIRECT: 직송
 */
export const translateGoodsInventoryType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'DAY': tokens.code.invn_typ_day,
        'KEEP': tokens.code.invn_typ_keep,
        'DIRECT': tokens.code.invn_typ_direct,
    });
};

/*
C: 냉장
F: 냉동
R: 실온
 */
export const translateGoodsTemperature = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'C': tokens.code.gd_tmp_typ_c,
        'F': tokens.code.gd_tmp_typ_f,
        'R': tokens.code.gd_tmp_typ_r,
    });
};

/*
코드그룹: GD_TYP
G: 범용
E: 전용
 */
export const translateGoodsType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'G': tokens.code.gd_typ_g,
        'E': tokens.code.gd_typ_e,
    });
};

/*
DIRECT: 자체배송
PR: 발주요청
PX: 발주취소
IW: 입고대기
IK: 입고확인
IC: 입고완료
IF: 입고확정
*/
export const translatePurchaseOrderStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'DIRECT': tokens.code.pr_stt_direct,
        'PR': tokens.code.pr_stt_pr,
        'PX': tokens.code.pr_stt_px,
        'IW': tokens.code.pr_stt_iw,
        'IK': tokens.code.pr_stt_ik,
        'IC': tokens.code.pr_stt_ic,
        'IF': tokens.code.pr_stt_if,
    });
};

/*
AB: 페기처리
RX: 반품취소
RR: 반품접수
RC: 반품요청(확정)
*/
export const translatePurchaseReturnStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t,{
        'AB': tokens.code.rtrn_prog_ab,
        'RX': tokens.code.rtrn_prog_rx,
        'RR': tokens.code.rtrn_prog_rr,
        'RC': tokens.code.rtrn_prog_rc,
    });
};

/*
BD: 상품 불량
BK: 상품 파손
SP: 유통기한 경과
*/
export const translatePurchaseReturnType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t,{
        'BD': tokens.code.rtrn_typ_bd,
        'BK': tokens.code.rtrn_typ_bk,
        'SP': tokens.code.rtrn_typ_sp,
    });
};

/*
CF: 확정완료
NY: 미확정
*/
export const translatePurchaseSettlementStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t,{
        'BD': tokens.code.pc_stl_typ_cf,
        'NY': tokens.code.pc_stl_typ_ny,
    });
};

/*
NPAID: 미납
PAID: 상환
*/
export const translateBondPayStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t,{
        'NPAID': tokens.code.bond_pay_stt_npaid,
        'PAID': tokens.code.bond_pay_stt_paid,
    });
};

/*
E: 종료
N: 정상
S: 정지
*/
export const translateCreditStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'E': tokens.code.crdt_stt_cd_e,
        'N': tokens.code.crdt_stt_cd_n,
        'S': tokens.code.crdt_stt_cd_s,
    });
};

/*
BOND_ADJ: 채권조정
CLAIM: 클레임
COAST: 비용청구
ETC: 기타
PURCHASE: 사입비
QUICK: 퀵비
QUICK_PURCHASE: 퀵/사입
SALES_ADJ: 매출조정
*/
export const translateAdjustmentPriceCategory = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'BOND_ADJ': tokens.code.adj_price_category_bond_adj,
        'CLAIM': tokens.code.adj_price_category_claim,
        'COAST': tokens.code.adj_price_category_coast,
        'ETC': tokens.code.adj_price_category_etc,
        'PURCHASE': tokens.code.adj_price_category_purchase,
        'QUICK': tokens.code.adj_price_category_quick,
        'QUICK_PURCHASE': tokens.code.adj_price_category_quick_purchase,
        'SALES_ADJ': tokens.code.adj_price_category_sales_adj,
    });
};

/*
CENTER_MNG: 센터관리자
CONSULTANT: 상담원
DLVR_MNG: 배송매니저
INBOUND: 입고지센터
LOGISTICS: 물류사
OUTBOUND: 출차지센터
PC_MNG: 구매담당자
PURCHASE: 매입처
SALES: 매출처
SALES_MNG: 영업담당자
*/
export const translateSubjectResponsibility = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'CENTER_MNG': tokens.code.sbjct_rspns_center_mng,
        'CONSULTANT': tokens.code.sbjct_rspns_consultant,
        'DLVR_MNG': tokens.code.sbjct_rspns_dlvr_mng,
        'INBOUND': tokens.code.sbjct_rspns_inbound,
        'LOGISTICS': tokens.code.sbjct_rspns_logistics,
        'OUTBOUND': tokens.code.sbjct_rspns_outbound,
        'PC_MNG': tokens.code.sbjct_rspns_pc_mng,
        'PURCHASE': tokens.code.sbjct_rspns_purchase,
        'SALES': tokens.code.sbjct_rspns_sales,
        'SALES_MNG': tokens.code.sbjct_rspns_sales_mng,
    });
};

/*
CF: 확정완료
ER: 정산에러
FF: 강제확정
NY: 미확정
*/
export const translateSalesSettlementStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'CF': tokens.code.sls_stl_typ_cf,
        'ER': tokens.code.sls_stl_typ_er,
        'FF': tokens.code.sls_stl_typ_ff,
        'NY': tokens.code.sls_stl_typ_ny,
    });
};

/*
POSTPAY: 후불
PREPAY: 선불
*/
export const translateSalesContractType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'POSTPAY': tokens.code.sls_ctt_postpay,
        'PREPAY': tokens.code.sls_ctt_prepay,
    });
};

/*
DIRECT: 자체배송
IC: 입고완료
IF: 입고확정
IK: 입고확인
IW: 입고대기
PR: 발주요청
PX: 발주취소
*/
export const translatePurchaseRequestStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'DIRECT': tokens.code.pr_stt_direct,
        'IC': tokens.code.pr_stt_ic,
        'IF': tokens.code.pr_stt_if,
        'IK': tokens.code.pr_stt_ik,
        'IW': tokens.code.pr_stt_iw,
        'PR': tokens.code.pr_stt_pr,
        'PX': tokens.code.pr_stt_px,
    });
};

/*
FI: 강제입고
MI: 미입고
NI: 정상입고
PI: 부분입고
*/
export const translatePurchaseOrderInboundStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'FI': tokens.code.po_inb_stt_fi,
        'MI': tokens.code.po_inb_stt_mi,
        'NI': tokens.code.po_inb_stt_ni,
        'PI': tokens.code.po_inb_stt_pi,
    });
};

/*
BAD_02: 상품불량
BAD_BREAK: 상품불량 파손
BRK_CRM_2: 파손
CHN_MIND: 단순변심
COP_CRM_2: 전산문의
COR_DLVR_02: 대응배송
CRE_CRM_2: 결제문의
DLVR_CRM_2: 배송문의
DMG_PY_2: 재화파손
DOC_CRM_2: 서류요청
DOR_LCK_2: 출입문미시건
ERR_CODE_02: 에러코드
ERR_STACK_02: 오적재
ERROR: 오배송
ETC: 기타
ETC_02: 기타문의
EXPIRED: 유통기한
MISS: 미배송
NO_ST_CRM2: 미입고
OPEN_CLO_2: 냉장고개폐
ORD_CRM_02: 발주문의
OVER_ST_2: 과입고
PRO_CRM_2: 제품문의
SUP_DATA_02: 증빙자료
UNRECOVER2: 미회수
WRG_ORD_2: 오발주
WRG_STO_2: 오입고
*/
export const translateReasonForSubmission = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'BAD_02': tokens.code.rqsts_bad_02,
        'BAD_BREAK': tokens.code.rqsts_bad_break,
        'BRK_CRM_2': tokens.code.rqsts_brk_crm_2,
        'CHN_MIND': tokens.code.rqsts_chn_mind,
        'COP_CRM_2': tokens.code.rqsts_cop_crm_2,
        'COR_DLVR_02': tokens.code.rqsts_cor_dlvr_02,
        'CRE_CRM_2': tokens.code.rqsts_cre_crm_2,
        'DLVR_CRM_2': tokens.code.rqsts_dlvr_crm_2,
        'DMG_PY_2': tokens.code.rqsts_dmg_py_2,
        'DOC_CRM_2': tokens.code.rqsts_doc_crm_2,
        'DOR_LCK_2': tokens.code.rqsts_dor_lck_2,
        'ERR_CODE_02': tokens.code.rqsts_err_code_02,
        'ERR_STACK_02': tokens.code.rqsts_err_stack_02,
        'ERROR': tokens.code.rqsts_error,
        'ETC': tokens.code.rqsts_etc,
        'ETC_02': tokens.code.rqsts_etc_02,
        'EXPIRED': tokens.code.rqsts_expired,
        'MISS': tokens.code.rqsts_miss,
        'NO_ST_CRM2': tokens.code.rqsts_no_st_crm2,
        'OPEN_CLO_2': tokens.code.rqsts_open_clo_2,
        'ORD_CRM_02': tokens.code.rqsts_ord_crm_02,
        'OVER_ST_2': tokens.code.rqsts_over_st_2,
        'PRO_CRM_2': tokens.code.rqsts_pro_crm_2,
        'SUP_DATA_02': tokens.code.rqsts_sup_data_02,
        'UNRECOVER2': tokens.code.rqsts_unrecover2,
        'WRG_ORD_2': tokens.code.rqsts_wrg_ord_2,
        'WRG_STO_2': tokens.code.rqsts_wrg_sto_2,
    });
};

/*
TC: 회수완료
TG: 회수중
TX: 회수취소
*/
export const translateTakeBackStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'TC': tokens.code.tkbck_prog_tc,
        'TG': tokens.code.tkbck_prog_tg,
        'TX': tokens.code.tkbck_prog_tx,
    });
};

/*
DONE: 회수정상종료
FC: 완료
N: 미처리
PC: 부분완료
R: 대기중
*/
export const translateTakeBackProcessStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'DONE': tokens.code.tkbck_prcsn_done,
        'FC': tokens.code.tkbck_prcsn_fc,
        'N': tokens.code.tkbck_prcsn_n,
        'PC': tokens.code.tkbck_prcsn_pc,
        'R': tokens.code.tkbck_prcsn_r,
    });
};

/*
AB: 폐기
GQ: 양품화
QW: 양품대기
RET: 반품
*/
export const translateTakeBackInbound = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'AB': tokens.code.tkbck_inb_ab,
        'GQ': tokens.code.tkbck_inb_gq,
        'QW': tokens.code.tkbck_inb_qw,
        'RET': tokens.code.tkbck_inb_ret,
    });
};

/*
AB: 자체폐기
C: 센터회수
*/
export const translateTakeBackDelivery = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'AB': tokens.code.tkbck_dlv_ab,
        'C': tokens.code.tkbck_dlv_c,
    });
};

/*
IC: 입고완료
IN_DLV: 배송중
IW: 입고대기
PRTL_DLV: 부분배송
XI: 미입고
*/
export const translateMiddleMileInboundStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'IC': tokens.code.mdlml_inb_stt_ic,
        'IN_DLV': tokens.code.mdlml_inb_stt_in_dlv,
        'IW': tokens.code.mdlml_inb_stt_iw,
        'PRTL_DLV': tokens.code.mdlml_inb_stt_prtl_dlv,
        'XI': tokens.code.mdlml_inb_stt_xi,
    });
};

/*
DC: 배송완료
DD: 배송지연
DW: 배송중
OC: 주문확정
OR: 주문접수
OX: 주문취소
PD: 부분배송
*/
export const translateOrderProgress = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'DC': tokens.code.ord_prog_dc,
        'DD': tokens.code.ord_prog_dd,
        'DW': tokens.code.ord_prog_dw,
        'OC': tokens.code.ord_prog_oc,
        'OR': tokens.code.ord_prog_or,
        'OX': tokens.code.ord_prog_ox,
        'PD': tokens.code.ord_prog_pd,
    });
};

/*
OK: 정상
OX: 전체취소
PC: 부분취소
*/
export const translateOrderCancel = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'OK': tokens.code.ord_cancel_ok,
        'OX': tokens.code.ord_cancel_ox,
        'PC': tokens.code.ord_cancel_pc,
    });
};

/*
E: 미출
EL: 미상차
K: 확인필요
N: 정상
PD: 부분배송
Q: 선출고
RO: 재출고
X: 취소
*/
export const translateOutboundStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'E': tokens.code.outb_stt_e,
        'EL': tokens.code.outb_stt_el,
        'K': tokens.code.outb_stt_k,
        'N': tokens.code.outb_stt_n,
        'PD': tokens.code.outb_stt_pd,
        'Q': tokens.code.outb_stt_q,
        'RO': tokens.code.outb_stt_ro,
        'X': tokens.code.outb_stt_x,
    });
};

/*
EMRG: 긴급출고
LAST: 지선
MID: 간선
*/
export const translateOutboundType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'EMRG': tokens.code.outb_typ_emrg,
        'LAST': tokens.code.outb_typ_last,
        'MID': tokens.code.outb_typ_mid,
    });
};

/*
E: 미출
EL: 미상차
K: 확인필요
N: 정상
PD: 부분배송
Q: 선출고
RO: 재출고
X: 취소
*/
export const translateIssueSource = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'E': tokens.code.issu_src_e,
        'EL': tokens.code.issu_src_el,
        'K': tokens.code.issu_src_k,
        'N': tokens.code.issu_src_n,
        'PD': tokens.code.issu_src_pd,
        'Q': tokens.code.issu_src_q,
        'RO': tokens.code.issu_src_ro,
        'X': tokens.code.issu_src_x,
    });
};

/*
E: 긴급출고
O: 출고지시
R: 요청취소
RO: 재출고지시
X: 주문취소
*/
export const translateCenterIssue = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'E': tokens.code.center_issu_e,
        'O': tokens.code.center_issu_o,
        'R': tokens.code.center_issu_r,
        'RO': tokens.code.center_issu_ro,
        'X': tokens.code.center_issu_x,
    });
};

/*
CR: 고객요청
DD: 배송지연
ET: 기타
GB: 상품불량,파손
IE: 재고부족
*/
export const translateIssueReason = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'CR': tokens.code.issu_prcsn_cr,
        'DD': tokens.code.issu_prcsn_dd,
        'ET': tokens.code.issu_prcsn_et,
        'GB': tokens.code.issu_prcsn_gb,
        'IE': tokens.code.issu_prcsn_ie,
    });
};

/*
AB: 폐기
DEFECTIVE: 불량
LOS: 손망실 처리
ML: 미상차
RCV: 손망실복구
SHL: 유통기한 조정
*/
export const translateInventoryAdjustmentType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'AB': tokens.code.invn_adjs_typ_ab,
        'DEFECTIVE': tokens.code.invn_adjs_typ_defective,
        'LOS': tokens.code.invn_adjs_typ_los,
        'ML': tokens.code.invn_adjs_typ_ml,
        'RCV': tokens.code.invn_adjs_typ_rcv,
        'SHL': tokens.code.invn_adjs_typ_shl,
        'LOT': tokens.code.invn_adjs_typ_lot,
    });
};

/*
C: 완료
F: 확정
W: 진행중
*/
export const translateInventorySurveyStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'C': tokens.code.invnsu_prog_c,
        'F': tokens.code.invnsu_prog_f,
        'W': tokens.code.invnsu_prog_w,
    });
};

/*
AB: 폐기
CI: 창간입고
CO: 창간출고
DEFECTIVE: 불량
IN: 입고
LOS: 손망실 처리
MOV: 이동
OUT: 출고
RCV: 손망실복구
RET: 반품
SHL: 유통기한 조정
TB: 회수
*/
export const translateInventoryPrcsnCd = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'AB': tokens.code.invn_prcsn_ab,
        'CI': tokens.code.invn_prcsn_ci,
        'CO': tokens.code.invn_prcsn_co,
        'DEFECTIVE': tokens.code.invn_prcsn_defective,
        'IN': tokens.code.invn_prcsn_in,
        'LOS': tokens.code.invn_prcsn_los,
        'MOV': tokens.code.invn_prcsn_mov,
        'OUT': tokens.code.invn_prcsn_out,
        'RCV': tokens.code.invn_prcsn_rcv,
        'RET': tokens.code.invn_prcsn_ret,
        'SHL': tokens.code.invn_prcsn_shl,
        'LOT': tokens.code.invn_adjs_typ_lot,
        'TB': tokens.code.invn_prcsn_tb,
    });
};

/*
    group : INVN_MV_TYP
    C : 창간이동
    M: 재고이동
*/
export const translateInventoryMoveTyp = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'C': tokens.code.invn_mv_typ_c,
        'M': tokens.code.invn_mv_typ_m,
    });
};

/*
    group : INVN_MV_PROG
    N : 미적치
    C: 완료
    X: 취소
*/
export const translateInventoryMoveProg = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'N': tokens.code.invn_mv_prog_n,
        'C': tokens.code.invn_mv_prog_c,
        'X': tokens.code.invn_my_prog_x,
    });
};


/*
BD: 조정존
DB: 분배존
ET: 기타
IN: 입고존
JB: 작업존
KP: 보관존
MV: 이동존
OT: 출고존
PK: 피킹존
RT: 반품존
TK: 회수존
*/
export const translateLocationType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'BD': tokens.code.lct_typ_bd,
        'DB': tokens.code.lct_typ_db,
        'ET': tokens.code.lct_typ_et,
        'IN': tokens.code.lct_typ_in,
        'JB': tokens.code.lct_typ_jb,
        'KP': tokens.code.lct_typ_kp,
        'MV': tokens.code.lct_typ_mv,
        'OT': tokens.code.lct_typ_ot,
        'PK': tokens.code.lct_typ_pk,
        'RT': tokens.code.lct_typ_rt,
        'TK': tokens.code.lct_typ_tk,
    });
};


/*
DLV_CPL: 배송완료
IN_DLV: 배송중
INB_WAIT: 입차대기중
LOAD_INSPC: 상차검수중
LOAD_WAIT: 상차대기중
*/
export const translateDeliveryStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'DLV_CPL': tokens.code.tm_dlv_stat_dlv_cpl,
        'IN_DLV': tokens.code.tm_dlv_stat_in_dlv,
        'INB_WAIT': tokens.code.tm_dlv_stat_inb_wait,
        'LOAD_INSPC': tokens.code.tm_dlv_stat_load_inspc,
        'LOAD_WAIT': tokens.code.tm_dlv_stat_load_wait,
    });
};

/*
LAST: 지선
MID: 간선
*/
export const translateDeliveryType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'LAST': tokens.code.dlv_ml_last,
        'MID': tokens.code.dlv_ml_mid,
    });
};

/*
PRSNL: 개인
TRNSP: 운수사
*/
export const translateDeliveryBusinessType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'PRSNL': tokens.code.tm_biz_type_prsnl,
        'TRNSP': tokens.code.tm_biz_type_trnsp,
    });
};

/*
CNTR_END: 계약종료
UNDER_CNTR: 계약중
*/
export const translateDeliveryContractStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'CNTR_END': tokens.code.tm_cntr_stat_cntr_end,
        'UNDER_CNTR': tokens.code.tm_cntr_stat_under_cntr,
    });
};

/*
BFE: 종료임박
CON: 계약중
END: 종료
STP: 이용정지
*/
export const translateSalesContractStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'BFE': tokens.code.sls_stt_bfe,
        'CON': tokens.code.sls_stt_con,
        'END': tokens.code.sls_stt_end,
        'STP': tokens.code.sls_stt_stp,
    });
};

/*
NEXT_MTH: 익월
*/
export const translatePayMonth = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'NEXT_MTH': tokens.code.stlprg_mnt_next_mth,
    });
};


/*
1: 1
10: 10
15: 15
20: 20
25: 25
5: 5
LAST: 말일
*/
export const translateStandDate = (code: string | undefined, t: (key: string) => string) => {
    let text = translateText(code, t, {
        '1': tokens.code.stand_dt_1,
        '10': tokens.code.stand_dt_10,
        '15': tokens.code.stand_dt_15,
        '20': tokens.code.stand_dt_20,
        '25': tokens.code.stand_dt_25,
        '5': tokens.code.stand_dt_5,
        'LAST': tokens.code.stand_dt_last,
    });

    return code === 'LAST' ? text.replace('일', '').replace('日', '') : text
};

/*
CLAIM: 클레임
COMMON: 일반
ISSUE: 출고이슈
MSG: 문자발송
RECALL: 반품/교환
URGNT_DLVR: 긴급출고
*/
export const translateConsultationType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'CLAIM': tokens.code.cnsln_typ_cd_claim,
        'COMMON': tokens.code.cnsln_typ_cd_common,
        'ISSUE': tokens.code.cnsln_typ_cd_issue,
        'MSG': tokens.code.cnsln_typ_cd_msg,
        'RECALL': tokens.code.cnsln_typ_cd_recall,
        'URGNT_DLVR': tokens.code.cnsln_typ_cd_urgnt_dlvr,
    });
};

/*
BREAK_CRM_01: 파손
COMP_CRM_01: 전산문의
CR_DLVR_1: 대응배송
CREDT_CRM_01: 결제문의
DLVR_CRM_01: 배송문의
DLVR_RT: 배송 • 회수 문의
DMG_PY_01: 재화파손
DOCU_CRM_01: 서류요청
DOOR_LO_1: 출입문미시건
ER_CODE_1: 에러코드
ERR_ST_1: 오적재
ETC: 기타 문의
ETC_01: 기타문의
GOODS_INQ: 상품 문의
NO_ST_CR_1: 미입고
OPEN_CL_1: 냉장고개폐
ORD_CRM_01: 발주문의
ORD_STL: 주문 • 정산 문의
OVER_ST_1: 과입고
PROD_CRM_01: 제품문의
SUP_DA_01: 증빙자료
SYS: 시스템 문의
UNRECOVER_01: 미회수
WNG_OR_1: 오발주
WNG_ST_1: 오입고
*/
export const translateInquiryType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'BREAK_CRM_01': tokens.code.crm_gnr_inq_break_crm_01,
        'COMP_CRM_01': tokens.code.crm_gnr_inq_comp_crm_01,
        'CR_DLVR_1': tokens.code.crm_gnr_inq_cr_dlvr_1,
        'CREDT_CRM_01': tokens.code.crm_gnr_inq_cred_crm_01,
        'DLVR_CRM_01': tokens.code.crm_gnr_inq_dlvr_crm_01,
        'DLVR_RT': tokens.code.crm_gnr_inq_dlvr_rt,
        'DMG_PY_01': tokens.code.crm_gnr_inq_dmg_py_01,
        'DOCU_CRM_01': tokens.code.crm_gnr_inq_docu_crm_01,
        'DOOR_LO_1': tokens.code.crm_gnr_inq_door_lo_1,
        'ER_CODE_1': tokens.code.crm_gnr_inq_er_code_1,
        'ERR_ST_1': tokens.code.crm_gnr_inq_err_st_1,
        'ETC': tokens.code.crm_gnr_inq_etc,
        'ETC_01': tokens.code.crm_gnr_inq_etc_01,
        'GOODS_INQ': tokens.code.crm_gnr_inq_goods_inq,
        'NO_ST_CR_1': tokens.code.crm_gnr_inq_no_st_cr_1,
        'OPEN_CL_1': tokens.code.crm_gnr_inq_open_cl_1,
        'ORD_CRM_01': tokens.code.crm_gnr_inq_ord_crm_01,
        'ORD_STL': tokens.code.crm_gnr_inq_ord_stl,
        'OVER_ST_1': tokens.code.crm_gnr_inq_over_st_1,
        'PROD_CRM_01': tokens.code.crm_gnr_inq_prod_crm_01,
        'SUP_DA_01': tokens.code.crm_gnr_inq_sup_da_01,
        'SYS': tokens.code.crm_gnr_inq_sys,
        'UNRECOVER_01': tokens.code.crm_gnr_inq_unrecover_01,
        'WNG_OR_1': tokens.code.crm_gnr_inq_wng_or_1,
        'WNG_ST_1': tokens.code.crm_gnr_inq_wng_st_1,
    });
};

/*
BAD: 상품불량
BAD_PACK: 포장불량
BREAK: 상품파손
BREAK_CRM: 파손
COMP_CRM: 전산문의
COR_DLVR: 대응배송
CREDT_CRM: 결제문의
DLVR_CRM: 배송문의
DLY_DLVR: 지연배송
DMG_PRY: 재화파손
DOCU_CRM: 서류요청
DOOR_LOCK: 출입문미시건
ERR_CODE: 에러코드
ERR_LN_BD: 여신・채권 오류
ERR_ORD: 주문불가 오류
ERR_PRICE: 정산금액 오류
ERR_RECALL: 오회수
ERR_STACK: 오적재
ETC: 기타
EXPIRED_DT: 유통기한
MISDLVR: 오배송
NO_ST_CR: 미입고
OPEN_CLOSE: 냉장고개폐
ORD_CRM: 발주문의
OVER_ST: 과입고
PROD_CRM: 제품문의
SUP_DA: 증빙자료
UNDLVR: 미배송
UNRECOVER: 미회수
WRG_ORD: 오발주
WRG_ST: 오입고
*/
export const translateInquiryDetailType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'BAD': tokens.code.crm_dtl_ty_bad,
        'BAD_PACK': tokens.code.crm_dtl_ty_bad_pack,
        'BREAK': tokens.code.crm_dtl_ty_break,
        'BREAK_CRM': tokens.code.crm_dtl_ty_break_crm,
        'COMP_CRM': tokens.code.crm_dtl_ty_comp_crm,
        'COR_DLVR': tokens.code.crm_dtl_ty_cor_dlvr,
        'CREDT_CRM': tokens.code.crm_dtl_ty_cred_crm,
        'DLVR_CRM': tokens.code.crm_dtl_ty_dlvr_crm,
        'DLY_DLVR': tokens.code.crm_dtl_ty_dly_dlvr,
        'DMG_PRY': tokens.code.crm_dtl_ty_dmg_pry,
        'DOCU_CRM': tokens.code.crm_dtl_ty_docu_crm,
        'DOOR_LOCK': tokens.code.crm_dtl_ty_door_lock,
        'ERR_CODE': tokens.code.crm_dtl_ty_err_code,
        'ERR_LN_BD': tokens.code.crm_dtl_ty_err_ln_bd,
        'ERR_ORD': tokens.code.crm_dtl_ty_err_ord,
        'ERR_PRICE': tokens.code.crm_dtl_ty_err_price,
        'ERR_RECALL': tokens.code.crm_dtl_ty_err_recall,
        'ERR_STACK': tokens.code.crm_dtl_ty_err_stack,
        'ETC': tokens.code.crm_dtl_ty_etc,
        'EXPIRED_DT': tokens.code.crm_dtl_ty_expired_dt,
        'MISDLVR': tokens.code.crm_dtl_ty_misdlvr,
        'NO_ST_CR': tokens.code.crm_dtl_ty_no_st_cr,
        'OPEN_CLOSE': tokens.code.crm_dtl_ty_open_close,
        'ORD_CRM': tokens.code.crm_dtl_ty_ord_crm,
        'OVER_ST': tokens.code.crm_dtl_ty_over_st,
        'PROD_CRM': tokens.code.crm_dtl_ty_prod_crm,
        'SUP_DA': tokens.code.crm_dtl_ty_sup_da,
        'UNDLVR': tokens.code.crm_dtl_ty_undlvr,
        'UNRECOVER': tokens.code.crm_dtl_ty_unrecover,
        'WRG_ORD': tokens.code.crm_dtl_ty_wrg_ord,
        'WRG_ST': tokens.code.crm_dtl_ty_wrg_st,
    });
};

/*
APPROVE: 반품승인
RECEIPT: 접수
REJECT: 반려
*/
export const translateReturnRequestStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'APPROVE': tokens.code.return_stt_cd_approve,
        'RECEIPT': tokens.code.return_stt_cd_receipt,
        'REJECT': tokens.code.return_stt_cd_reject,
    });
};

/*
DONE: 완료
INCOMPLETE: 미완료
RC: 요청취소
*/
export const translateConsultationProcessingStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'DONE': tokens.code.prcsn_stt_cd_done,
        'INCOMPLETE': tokens.code.prcsn_stt_cd_incomplete,
        'RC': tokens.code.prcsn_stt_cd_rc,
    });
};

/*
E: 교환
R: 반품
*/
export const translateCRMProcessType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'E': tokens.code.crm_process_type_e,
        'R': tokens.code.crm_process_type_r,
    });
};

/*
BASC_ASK: 일반문의
BREAK_BAD: 상품 파손 • 불량
CLAIM_ASK: 클레임
DLVR_RT: 배송 • 회수
ETC_ASK: 기타
ORD_STL: 주문 • 정산
*/
export const translateCRMClaimInquiryType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'BASC_ASK': tokens.code.crm_type_basc_ask,
        'BREAK_BAD': tokens.code.crm_type_break_bad,
        'CLAIM_ASK': tokens.code.crm_type_claim_ask,
        'DLVR_RT': tokens.code.crm_type_dlvr_rt,
        'ETC_ASK': tokens.code.crm_type_etc_ask,
        'ORD_STL': tokens.code.crm_type_ord_stl,
    });
};

/*
NOTI: 공지중
NOTI_END: 공지 종료
*/
export const translateNoticeStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'NOTI': tokens.code.noti_state_noti,
        'NOTI_END': tokens.code.noti_state_noti_end,
    });
};

/*
BRAND_CAL: 채권•정산
ETC: 기타
GOODS: 상품
ORD_DELI: 주문•배송
SYSTEM: 시스템
*/
export const translateNoticeCategory = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'BRAND_CAL': tokens.code.notice_ctg_brand_cal,
        'ETC': tokens.code.notice_ctg_etc,
        'GOODS': tokens.code.notice_ctg_goods,
        'ORD_DELI': tokens.code.notice_ctg_ord_deli,
        'SYSTEM': tokens.code.notice_ctg_system,
    });
};

/*
CASH: 현금
CREDIT: 신용
PGRNT: 이행보증보험
*/
export const translateGrntTyp = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'CASH': tokens.code.grnt_typ_cash,
        'CREDIT': tokens.code.grnt_typ_credit,
        'PGRNT': tokens.code.grnt_typ_pgrnt,
    });
};

/*
DLV_CPL: 배송완료
IN_DLV: 배송중
NO_DLV: 미배송
PRTL_DLV: 부분배송
*/
export const translateTmDeliveryCompleteStatus = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'DLV_CPL': tokens.code.tm_dlv_cpl_stat_dlv_cpl,
        'IN_DLV': tokens.code.tm_dlv_cpl_stat_in_dlv,
        'NO_DLV': tokens.code.tm_dlv_cpl_stat_no_dlv,
        'PRTL_DLV': tokens.code.tm_dlv_cpl_stat_prtl_dlv,
    });
};

/*
D: 국내산
I: 수입산
O: 기타
*/
export const translateOriginType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'D': tokens.code.orgn_typ_d,
        'I': tokens.code.orgn_typ_i,
        'O': tokens.code.orgn_typ_o,
    });
};

export const translateNation = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'AE': tokens.code.nation_ae, // 아랍에미리트
        'AM': tokens.code.nation_am, // 미국
        'AN': tokens.code.nation_an, // 아르헨티나
        'AS': tokens.code.nation_as, // 오스트리아
        'AU': tokens.code.nation_au, // 호주
        'BG': tokens.code.nation_bg, // 벨기에
        'BR': tokens.code.nation_br, // 바레인
        'BZ': tokens.code.nation_bz, // 브라질
        'CA': tokens.code.nation_ca, // 캐나다
        'CB': tokens.code.nation_cb, // 콜롬비아
        'CH': tokens.code.nation_ch, // 칠레
        'CN': tokens.code.nation_cn, // 중국
        'CR': tokens.code.nation_cr, // 코스타리카
        'DM': tokens.code.nation_dm, // 덴마크
        'DN': tokens.code.nation_dn, // 도미니카
        'EG': tokens.code.nation_eg, // 이집트
        'ETC': tokens.code.nation_etc, // 외국산
        'FG': tokens.code.nation_fg, // 피지
        'FL': tokens.code.nation_fl, // 핀란드
        'FR': tokens.code.nation_fr, // 프랑스
        'GM': tokens.code.nation_gm, // 독일
        'GN': tokens.code.nation_gn, // 기니
        'GR': tokens.code.nation_gr, // 그리스
        'HK': tokens.code.nation_hk, // 홍콩
        'ID': tokens.code.nation_id, // 인도
        'IDN': tokens.code.nation_idn, // 인도네시아
        'IL': tokens.code.nation_il, // 아일랜드
        'IR': tokens.code.nation_ir, // 이란
        'IS': tokens.code.nation_is, // 이스라엘
        'IT': tokens.code.nation_it, // 이탈리아
        'JP': tokens.code.nation_jp, // 일본
        'MC': tokens.code.nation_mc, // 멕시코
        'MGC': tokens.code.nation_mgc, // 마다가스카르
        'MN': tokens.code.nation_mn, // 모나코
        'MR': tokens.code.nation_mr, // 모로코
        'MS': tokens.code.nation_ms, // 말레이시아
        'MT': tokens.code.nation_mt, // 모리타니아
        'MY': tokens.code.nation_my, // 미얀마
        'ND': tokens.code.nation_nd, // 네덜란드
        'NG': tokens.code.nation_ng, // 나이지리아
        'NW': tokens.code.nation_nw, // 노르웨이
        'NZ': tokens.code.nation_nz, // 뉴질랜드
        'PC': tokens.code.nation_pc, // 파키스탄
        'PF': tokens.code.nation_pf, // 태평양
        'PFC': tokens.code.nation_pfc, // 태평양
        'PG': tokens.code.nation_pg, // 파라과이
        'PL': tokens.code.nation_pl, // 폴란드
        'PP': tokens.code.nation_pp, // 필리핀
        'PR': tokens.code.nation_pr, // 페루
        'PT': tokens.code.nation_pt, // 포르투갈
        'RSA': tokens.code.nation_rsa, // 남아프리카공화국
        'RU': tokens.code.nation_ru, // 러시아
        'SB': tokens.code.nation_sb, // 세르비아
        'SD': tokens.code.nation_sd, // 사우디아라비아
        'SEA': tokens.code.nation_sea, // 원양
        'SG': tokens.code.nation_sg, // 세네갈
        'SGP': tokens.code.nation_sgp, // 싱가포르
        'SL': tokens.code.nation_sl, // 스리랑카
        'SP': tokens.code.nation_sp, // 스페인
        'SS': tokens.code.nation_ss, // 스위스
        'SW': tokens.code.nation_sw, // 스웨덴
        'TK': tokens.code.nation_tk, // 튀르키예
        'TL': tokens.code.nation_tl, // 태국
        'TS': tokens.code.nation_ts, // 튀니지
        'TW': tokens.code.nation_tw, // 대만
        'UB': tokens.code.nation_ub, // 우즈베키스탄
        'UK': tokens.code.nation_uk, // 영국
        'VT': tokens.code.nation_vt, // 베트남
    });
};

/*
ADJ: 조정금
EN: 해지
IN: 입금
MIG: 매출이관
OUT: 출금
ST: 생성
*/
export const translateBondType = (code: string, t: (key: string) => string) => {
    return translateText(code, t, {
        'ADJ': tokens.code.bond_typ_cd_adj,
        'EN': tokens.code.bond_typ_cd_en,
        'IN': tokens.code.bond_typ_cd_in,
        'MIG': tokens.code.bond_typ_cd_mig,
        'OUT': tokens.code.bond_typ_cd_out,
        'ST': tokens.code.bond_typ_cd_st,
    });
};

/*
코드그룹: INB_METHOD_TYP
PARCEL: 택배
TRUCK: 트럭
20FT: 20FT
40FT: 40FT
 */
export const translateInboundMethodType = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'PARCEL': tokens.code.parcel,
        'TRUCK': tokens.code.truck,
        '20FT': tokens.code.ft20,
        '40FT': tokens.code.ft40,
    });
};

/*
    IE : 입고예정
    IW : 입고대기
    UC : 입하완료
    MI : 미입고
    PI : 부분입고
 */
export const translateInboundProgCd = (code: string | undefined, t: (key: string) => string) => {
    return translateText(code, t, {
        'IE': tokens.code.inb_prog_cd_ie,
        'IW': tokens.code.inb_prog_cd_iw,
        'UC': tokens.code.inb_prog_cd_uc,
        'MI': tokens.code.inb_prog_cd_mi,
        'PI': tokens.code.inb_prog_cd_pi,
        'IC': tokens.code.inb_prog_cd_ic,
    });
};
